import { Button, Checkbox, DataHeader, DataSource, Label, Layout, Panel, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCompany extends Layout {
    buttonSendTestEmail: Button;
    checkboxAllowKeepSignedIn: Checkbox;
    checkboxAssetLTL: Checkbox;
    checkboxBRLTL: Checkbox;
    checkboxEnableMfa: Checkbox;
    checkboxEnablePortalMfa: Checkbox;
    checkboxEnableWebMfa: Checkbox;
    checkboxEncryptedDirectDeposit: Checkbox;
    checkboxEncryptedTaxID: Checkbox;
    checkboxIntercompanyCash: Checkbox;
    checkboxPhoneFormatting: Checkbox;
    checkboxTransferLog: Checkbox;
    checkboxUserAllowNewDevice: Checkbox;
    checkboxUserOverrideNewDevice: Checkbox;
    dataheaderCompany: DataHeader;
    labelK: Label;
    labelL1: Label;
    labelL: Label;
    labelM: Label;
    labelTestTitle: Label;
    layoutCompanyImage: Layout;
    panelCompanyDetails: Panel;
    panelCompanyImage: Panel;
    panelGeneral: Panel;
    panelMFAChecks: Panel;
    panelOutgoingEmailConfig: Panel;
    panelTestEmail: Panel;
    panelUserLicenseContact: Panel;
    sourceCompany: DataSource;
    sourceLoginSettings: DataSource;
    tabCompanyDetails: Tab;
    tabDocumentPower: Tab;
    tabGeneral: Tab;
    tabLoginSettings: Tab;
    tabOptions: Tab;
    tabOutgoingEmail: Tab;
    tabSecurity: Tab;
    tabUserLicenseContact: Tab;
    tabWeb: Tab;
    tabsetCompany: Tabset;
    textCompanyType: Textbox;
    textboxAddress1: Textbox;
    textboxAddress2: Textbox;
    textboxCC: Textbox;
    textboxCity: Textbox;
    textboxDefMoveType: Textbox;
    textboxDotNumber: Textbox;
    textboxDpImageMaxSize: Textbox;
    textboxEmail: Textbox;
    textboxEmailBcc: Textbox;
    textboxEmailClient: Textbox;
    textboxEmailHost: Textbox;
    textboxEmailPassword: Textbox;
    textboxEmailPort: Textbox;
    textboxEmailUsername: Textbox;
    textboxFax: Textbox;
    textboxFrom: Textbox;
    textboxIconImage: Textbox;
    textboxId: Textbox;
    textboxKeepSignedInDays: Textbox;
    textboxMaxFailedLogins: Textbox;
    textboxMessage: Textbox;
    textboxMfaPromptInterval: Textbox;
    textboxName: Textbox;
    textboxPhoneFormat: Textbox;
    textboxPhoneNumber: Textbox;
    textboxProtocol: Textbox;
    textboxScac: Textbox;
    textboxSecurityAdminEmail: Textbox;
    textboxState: Textbox;
    textboxSubject: Textbox;
    textboxSupportEmail: Textbox;
    textboxTo: Textbox;
    textboxTokenFinalExpiryMinutes: Textbox;
    textboxTokenIdleMinutes: Textbox;
    textboxUserLicContactEmail: Textbox;
    textboxUserLicContactName: Textbox;
    textboxUserLicContactPhone: Textbox;
    textboxWebAddress: Textbox;
    textboxWebsite: Textbox;
    textboxZip: Textbox;
}
